'use strict';
angular.module('fullImageUploadModule', []).controller('fullImageUploadCtrl', ['$scope', '$q', 'Upload', '$modalInstance', '$timeout', 'trsHttpService', 'options', 'modalDialog', 'getFileMD5Service',
    function($scope, $q, Upload, $modalInstance, $timeout, trsHttpService, options, modalDialog, getFileMD5Service) {
        initStatus();
        initData();

        function initStatus() {
            $scope.status = {
                uploadImg: {},
                showAddIcon: true, // 显示添加图标
                isShowRoutes: false, // 是否显示路径和上一级按钮
                isShowPeraonalMaterial: options.isShowPeraonalMaterial, // 是否显示添加到个人素材库的checkbox
                isAddPersonalMaterial: true // 是否选中添加到个人素材库
            };
            $scope.page = {
                ITEMCOUNT: '0',
                CURRPAGE: '1',
                PAGESIZE: '20',
                PAGECOUNT: '1'
            };
            $scope.data = {
                navs: [{
                    name: '我的图片',
                    value: '1'
                }, {
                    name: '本地图片',
                    value: '2'
                }],
                myPictures: [], // 我的图片列表
                selectedPicture: '', // 我的图片选中图片
                currFileId: '0', // 当前文件夹的id
                keywords: '', // 检索关键词
                uploadImages: [], // 本地上次的图片数组
                selectLocal: '', // 选择的本地图片
            };
            $scope.params = {
                'serviceid': 'mlf_releaseSource', // 服务名
                'methodname': 'queryPersonalMaterials', // 方法名
                'PersonalMaterialId': '0', // 主键，唯一性
                'status': '0', // 正常
                'fileType': '2', // 数据类型
                'order': '0', // 0：按创建时间排序，1：显示名称排序
                'searchValue': '', // 搜索内容
                'CurrPage': $scope.page.CURRPAGE,
                'PageSize': $scope.page.PAGESIZE
            };
            $scope.data.selectedNav = $scope.data.navs[0].value;
        }

        /**
         * [getAutoHeight description] 居中提示文字
         * @return {[type]} [description]
         */
        $scope.getAutoHeight = function() {
            $timeout(function() {
                var bodyHeight = $('.publicModal .body').height(),
                    fixedAreaHeight = $('.fixedArea').height();
                var contentHeight = bodyHeight - fixedAreaHeight;
                $('.uploadContent.localUpload').height(contentHeight);
            }, 500);
        };

        function initData() {
            requestData();
            getFileMD5Service.init();

            /* requirejs(['./lib/webuploader/webuploader'], function(WebUploader) {
                uploaderLazyLoad(WebUploader);
            });*/
        }

        /**
         * [upload description] 上传图片
         * @return {[type]} [description]
         */
        $scope.upload = function($files, $file, $newFiles) {
            if (!$newFiles) {return;}
            getFileMD5Service.getMd5($newFiles[0]).then(function(md5) {
                upload($newFiles[0], md5);
            }); 
        };

        /**
         * [upload description] 上传
         * @param {object} [file] [description] 文件
         * @return {[type]} [description]
         */
        function upload(file, md5) {
            
            if (file.size === 0) {
                return;
            }
            if (angular.isString(options.maxSize) && parseInt(options.maxSize) * Math.pow(1024, 2) < file.size) {
                modalDialog.alertType('上传图片的大小不可超过' + options.maxSize + 'MB', '', 'error', false);
                return;
            }

            var deffer = $q.defer();
            Upload.upload({
                url: '/wcm/openapi/uploadImage?md5=' + md5,
                data: {
                    file: file
                },
            }).then(function(resp) {
                var data = resp.data;
                if (data.error) {
                    modalDialog.alertType(data.error, '', 'error', false);
                } else {
                    if (data.imgSrc.indexOf('http') >= 0) {
                        var srcArray = data.imgSrc.split('/');
                        srcArray.splice(0, 3);
                        data.imgSrc = '/' + srcArray.join('/');
                    }
                    data.file = file;
                    $scope.status.uploadImg.src = data.imgSrc;
                    $scope.data.uploadImages.push(data);
                    
                    if (options.isFinish) {
                        isSavePersonal(data);
                    }
                    // $modalInstance.close({ data: $scope.data.uploadPictrues, isAddPersonalMaterial: $scope.status.isAddPersonalMaterial && $scope.data.selectedNav == '2' });
                }
                
            }, function(resp) {
                modalDialog.alertType('上传失败', '', 'error', false);
            }, function(evt) {

            });
        }

        /**
         * [finish description] 完成
         * @return {[type]} [description]
         */
        $scope.finish = function() {
            if ($scope.data.selectedNav == '1') {
                if (!$scope.data.selectedPicture) {
                    modalDialog.alertType('请选择图片', '', 'warning', false);
                    return;
                }
                addMyPictures();
            } else if ($scope.data.selectedNav == '2') {
                
                let data = $scope.data.selectLocal;
                $scope.data.uploadPictrues = {
                    file: {
                        size: data.file.size / 1024,
                        ext: data.imgName.split('.')[1]
                    },
                    src: {
                        imgName: data.imgName,
                        imgSrc: data.imgSrc,
                        imgDesc: data.orignalImg
                    }
                };
                if (angular.isUndefined($scope.data.uploadPictrues) || $scope.data.uploadPictrues.length === 0) {
                    modalDialog.alertType('请选择图片', '', 'warning', false);
                    return;
                }
                
                $modalInstance.close({ data: $scope.data.uploadPictrues, isAddPersonalMaterial: $scope.status.isAddPersonalMaterial && $scope.data.selectedNav == '2' });
            }
        };

        /**
         * [requestData description] 请求我的图片数据
         * @return {[type]} [description]
         */
        function requestData() {
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                $scope.data.myPictures = data.DATA;
                $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT; // 页数
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT; // 文件数量
                getFileRoutes();
            });
        }

        /**
         * [getFileRoutes description] 获取当前文件的导航
         * @return {[type]} [description]
         */
        function getFileRoutes() {
            if ($scope.data.currFileId == '0') {
                $scope.status.isShowRoutes = false;
                return;
            } else {
                var params = {
                    serviceid: 'mlf_releaseSource',
                    methodname: 'getPersonalMaterialDaoHang',
                    PersonalMaterialId: $scope.data.currFileId
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    var tempArray = [];
                    var ellipsisTitle = '';
                    // 导航长度大于3时，截取中间部分的导航串
                    for (var i = data.length - 1; i >= 0; i--) {
                        if (data.length > 3 && i < data.length && i > 0) {
                            ellipsisTitle += (i == data.length - 1) ? data[i].FILEDESC : ('>' + data[i].FILEDESC);
                        }
                        data[i].fileTitle = data[i].FILEDESC;
                        tempArray.push(data[i]);
                    }
                    // 添加根目录
                    $scope.data.routes = [{
                        FILEDESC: '全部文件',
                        PERSONALMATERIALID: '0',
                        fileTitle: '全部文件'
                    }].concat(tempArray);
                    $scope.data.allRoutes = angular.copy($scope.data.routes);
                    $scope.status.isShowRoutes = true;
                    var num = 0;
                    var last = false;
                    adjustWidth(num, last); // 若路径宽度超出最大宽度500px则调整
                });
            }
        }
        // 若路径宽度超出最大宽度500px则调整
        function adjustWidth(num, last) {
            $timeout(function() {
                if (angular.element('.searchBreadNav').width() > 500) {
                    if (num == $scope.data.routes.length - 1 && !last) { // 如果前面几个路径省略后宽度依然超出，则缩短最后一个
                        $scope.data.routes[num].FILEDESC = $scope.data.routes[num].FILEDESC.substring(0, 5) + '...';
                        last = true;
                        adjustWidth(num, last);
                    }
                    if (num > $scope.data.routes.length - 1) {return;}
                    $scope.data.routes[num].FILEDESC = '...';
                    if (num == $scope.data.routes.length - 1) {
                        num = $scope.data.routes.length - 1;
                        var mergenum = 1;
                        mergeBreadnav(mergenum);
                        return;
                    } else {
                        num++;
                    }
                    adjustWidth(num, last);
                } else {
                    return;
                }
            }, 20);
        }

        function mergeBreadnav(mergenum) {
            $timeout(function() {
                if (angular.element('.searchBreadNav').width() > 500) {
                    var tempArray = [];
                    var ellipsisTitle = '',
                        materialid = '';
                    var data = $scope.data.routes;
                    if (data.length === 1) {return;}
                    if (data.length === 2) {
                        for (var i = 0; i < (mergenum + 1); i++) {
                            ellipsisTitle += data[i].fileTitle + '>';
                            materialid += data[i].PERSONALMATERIALID + ',';
                        }
                        materialid = materialid.substring(0, materialid.length - 1);
                    } else {
                        for (var i = 0; i < (mergenum + 1); i++) {
                            ellipsisTitle += data[i].fileTitle + '>';
                        }
                    }
                    ellipsisTitle = ellipsisTitle.substring(0, ellipsisTitle.length - 1);
                    $scope.data.routes.splice(0, mergenum + 1, { // 点击...的时候调到根目录
                        FILEDESC: '... ...',
                        PERSONALMATERIALID: $scope.data.routes.length === 2 ? materialid : $scope.data.routes[mergenum].PERSONALMATERIALID,
                        fileTitle: ellipsisTitle,
                    });
                    mergeBreadnav(mergenum);
                } else {
                    return;
                }
            }, 20);
        }

        /**
         * [turnBackToPreviousRoute description] 返回上一级目录
         * @return {[type]} [description]
         */
        $scope.turnBackToPreviousRoute = function(currentRoute) {
            var routesLength = $scope.data.routes.length;
            if (routesLength === 1) { // 在路径被合并为一条的时候
                var allId = $scope.data.routes[0].PERSONALMATERIALID.split(','),
                    lastPERSONALMATERIALID = allId[allId.length - 2];
                var route = {
                    PERSONALMATERIALID: lastPERSONALMATERIALID // 把上一条的id存起来
                };
            } else {
                var route = $scope.data.routes[routesLength - 2];
            }
            var lastRoute = $scope.data.routes[routesLength - 1];
            if (currentRoute == 0) {
                turnBack(route);
            } else if (lastRoute.PERSONALMATERIALID != currentRoute.PERSONALMATERIALID) {
                turnBack(currentRoute);
            }
        };

        /**
         * [turnBackToAllFile description] 返回全部文件
         * @return {[type]} [description]
         */
        $scope.turnBackToAllFile = function() {
            var route = $scope.data.routes[0];
            turnBack(route);
        };

        /**
         * [turnBack description] 返回指定目录
         * @param  {[type]} route [description] 指定目录
         * @return {[type]}       [description]
         */
        function turnBack(route) {
            $scope.params.searchValue = '';
            $scope.data.keyWords = $scope.data.keywords = '';
            $scope.params.PersonalMaterialId = route.PERSONALMATERIALID;
            $scope.data.currFileId = route.PERSONALMATERIALID;
            $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
            $scope.status.copyCurrPage = 1;
            requestData();
        }

        /**
         * [search description] 搜索
         * @param  {[type]} ev [description] 键盘按键
         * @return {[type]}    [description]
         */
        $scope.search = function(ev) {
            if (angular.isDefined(ev) && ev.keyCode == 13) {
                $scope.params.searchValue = angular.copy($scope.data.keywords);
                $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
                $scope.status.copyCurrPage = 1;
                $scope.data.keyWords = $scope.data.keywords;
                requestData();
            }
        };

        /**
         * [changeNav description] 切换标签
         * @param  {[type]} nav [description] 标签数据
         * @return {[type]}    [description]
         */
        $scope.changeNav = function(nav) {
            $scope.data.selectedNav = nav.value;
            $scope.data.keyWords = $scope.data.keywords = '';
            if (nav.value == '2') {
                $scope.getAutoHeight();
            }
        };

        /**
         * [findChildrenFile description] 查看文件夹内的子文件，或文件详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.findChildrenFile = function(item) {
            if (item.FILETYPE == '0') {
                $scope.params.searchValue = '';
                $scope.params.PersonalMaterialId = item.PERSONALMATERIALID;
                $scope.data.currFileId = item.PERSONALMATERIALID;
                $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
                $scope.status.copyCurrPage = 1;
                $scope.data.keyWords = $scope.data.keywords = '';
                requestData();
            }
        };

        /**
         * [pageChanged description]跳转到下一页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.params.CurrPage = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
            $('.uploadRsource .body').animate({ scrollTop: 0 }, 'fast');
        };

        /**
         * [addMyPictures description] 添加我的图片
         * @param {[type]} uploadPic [description]
         */
        function addMyPictures() {
            var ext = $scope.data.selectedPicture.FILENAME.split('.');
            var data = {
                file: {
                    size: $scope.data.selectedPicture.FILESIZE,
                    ext: ext[ext.length - 1]
                },
                src: {
                    imgName: $scope.data.selectedPicture.FILENAME,
                    imgSrc: $scope.data.selectedPicture.SRCIMGURL
                }
            };
            $modalInstance.close({ data: data, isAddPersonalMaterial: $scope.status.isAddPersonalMaterial && $scope.data.selectedNav == '2' });
        }

        /**
         * [close description] 取消
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };

        /**
         * [isSavePersonal description]是否储存到个人素材
         * @return {Boolean} [description]
         */
        function isSavePersonal(item) {
            if ($scope.status.isAddPersonalMaterial == true && $scope.status.isShowPeraonalMaterial) {
                let picArr = new Array();
                picArr.push({
                    fileDesc: item.orignalImg,
                    PersonalMaterialId: '0',
                    fileSize: String(item.fileSizeOfKB),
                    fileName: item.imgName
                });
                var params = {
                    methodname: 'addPersonalMaterialOfImgs',
                    serviceid: 'mlf_releaseSource',
                    PersonalMaterialOfImgs: JSON.stringify(picArr),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {});
            }
        }

        /**
         * [isAddPersonalMaterial description]是否保存至个人素材库
         * @return {Boolean} [description]
         */
        $scope.isAddPersonalMaterial = function() {
            $scope.status.isAddPersonalMaterial = !$scope.status.isAddPersonalMaterial;
        };

        $scope.chooseLocal = function(item){
            
            $scope.data.selectLocal = item;
        };
    }
]);
